import resume from "../assets/pdf/Najd Feki Resume.pdf";

export const headerData = {
  name: "Najd Feki",
  title: "Software Engineer - Full Stack Developer",
  desciption:
    "Where there is a problem there is an opportunity to learn something new.",
  image: "https://avatars.githubusercontent.com/u/57197049?v=4",
  resumePdf: resume,
};
